// store key
export const SIDEBAR_KEY = 'sidebar';

// action types
export const SIDEBAR_TOGGLE = 'sidebar/TOGGLE';

// default store value
export const SIDEBAR_DEFAULT = {
  visible: false,
};



// WEBPACK FOOTER //
// ./src/store/actions/sidebar.types.js